var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{staticClass:"routerLink",attrs:{"to":_vm.navigateTo}},[_c('div',{class:[ _vm.light ? 'nav-button' : 'old-style']},[_vm._v("SEE MORE")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }